import { render, staticRenderFns } from "./familyListItem.vue?vue&type=template&id=425d945c&scoped=true"
import script from "./familyListItem.vue?vue&type=script&lang=js"
export * from "./familyListItem.vue?vue&type=script&lang=js"
import style0 from "./familyListItem.vue?vue&type=style&index=0&id=425d945c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425d945c",
  null
  
)

export default component.exports